<template>
	<i :class="iconClass">
		<svg aria-hidden="true" :class="svgClass">
			<use :xlink:href="`/static/build/gfx/${asset}`" />
		</svg>
	</i>
</template>

<script>
export default {
	name: 'UseIcon',

	props: {
		asset: String,
		iconClass: {
			type: String,
			default: 'icon'
		},
		svgClass: {
			type: String,
			default: ''
		}
	},
}
</script>
